var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-tag',{attrs:{"type":"danger","size":"medium"}},[_c('span',{staticClass:"el-icon-time"},[_vm._v(" "+_vm._s(_vm._f("formatTimer")(_vm.time)))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3aa794fa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/order-review/components/OrderReviewTimer.vue
// module id = 2344
// module chunks = 5 34